import React from 'react'

import CheckableTagStyled from './styled'

const CheckableTag = ({ enabled, ...props }) => (
  <CheckableTagStyled className="CheckableTag" {...props} type={enabled && 'primary'} />
)

export default CheckableTag
